import { render, staticRenderFns } from "./DrawerIcon.vue?vue&type=template&id=ff6ee444&scoped=true&"
import script from "./DrawerIcon.vue?vue&type=script&lang=js&"
export * from "./DrawerIcon.vue?vue&type=script&lang=js&"
import style0 from "./DrawerIcon.vue?vue&type=style&index=0&id=ff6ee444&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6ee444",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
